<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">留言管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>展示状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>回复状态：</label>
          <el-select v-model="isReplay" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isReplayArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="发表时间：" @date="getExpireTime($event)" @check="getExpireCheck($event)" :isChecked="isExpireChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="留言时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
<!--        <div class="content-input-item">-->
<!--          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />-->
<!--        </div>-->
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="batchUpdate(2)" v-loading="bitchPassLoading">批量通过</el-button>
          <el-button type="danger"  @click="batchUpdate(3)" v-loading="bitchRejectLoading">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" width="104"/>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="190">
            <template #default="scope">
              <UserInfoList :row="scope.row.resumeInfo" showList="name,phone"/>
            </template>
          </el-table-column>
          <el-table-column property="loveMsg" label="用户留言" v-if="checkColList.indexOf('用户留言') > -1" width="160"/>
          <el-table-column prop="" label="一伴回复" v-if="checkColList.indexOf('一伴回复') > -1" class-name="cursor" width="160">
            <template #default="scope">
              <p v-if="scope.row.replyLoveMsg">{{scope.row.replyLoveMsg.msg}}</p>
              <el-button type="text" v-else>回复</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="" label="回复状态" v-if="checkColList.indexOf('回复状态') > -1" width="90">
            <template #default="scope">
              {{scope.row.isReplay == 1 ? "未回复" : scope.row.isReplay == 2 ? "已回复" : "--"}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="展示状态" v-if="checkColList.indexOf('展示状态') > -1" width="90">
            <template #default="scope">
              <p>{{scope.row.state==1?'待审核':scope.row.state==2?'已通过':scope.row.state==3?'未通过':''}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="showTime" label="发表时间" width="104" v-if="checkColList.indexOf('发表时间') > -1"></el-table-column>
          <el-table-column prop="msg" label="三行情书内容" width="160" v-if="checkColList.indexOf('三行情书内容') > -1"></el-table-column>
          <el-table-column prop="" label="作者信息" width="120" v-if="checkColList.indexOf('作者信息') > -1">
            <template #default="scope">
              <p>昵称：{{scope.row.nickName}}</p>
              <p>性别：{{scope.row.sex == 1 ? "男" : scope.row.sex == 2 ? "女" : "--"}}</p>
              <p>年龄：{{scope.row.age}}</p>
              <p>城市：{{scope.row.city}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="文章点赞数" width="100" v-if="checkColList.indexOf('文章点赞数') > -1">
            <template #default="scope">
              <p>{{scope.row.letterLike}}/{{scope.row.letterShowLike}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="留言点赞数" width="100" v-if="checkColList.indexOf('留言点赞数') > -1">
            <template #default="scope">
              <p>{{scope.row.msgLike}}/{{scope.row.msgLikeShow}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="回复点赞数" width="100" v-if="checkColList.indexOf('回复点赞数') > -1">
            <template #default="scope">
              <p v-if="scope.row.replyLoveMsg">{{scope.row.replyLoveMsg.likeNum}}/{{scope.row.replyLoveMsg.likeShowNum}}</p>
              <p v-else>--</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getLoveMsgPageList, updateLoveMsgState,
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import MsgReplyDialog from "@/views/love/components/MsgReplyDialog";

export default {
  name: "LoveMsg",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      stateArray: [
        { label: "不限", value: -1 },
        { label: "待审核", value: 1 },
        { label: "已通过", value: 2 },
        { label: "未通过", value: 3 }
      ],
      state: 1,

      isReplayArray: [
        { label: "不限", value: -1 },
        { label: "待回复", value: 1 },
        { label: "已回复", value: 2 },
      ],
      isReplay: 1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //发表时间
      startExpire: '',
      endExpire: '',
      isExpireChecked: true,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['创建时间', '用户信息', '用户留言', '一伴回复', '回复状态', '展示状态', '发表时间','三行情书内容', '作者信息', '文章点赞数', '留言点赞数', '回复点赞数', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getExpireTime(val) {
      this.startExpire = val[0];
      this.endExpire = val[1];
      // console.log(val)
    },

    getExpireCheck(val) {
      this.isExpireChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isExpireChecked = true;
      this.state = 1;
      this.isReplay = 1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.msgId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.msgId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['isReplay'] = this.isReplay;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['startExpire'] = this.startExpire;
      param['endExpire'] = this.endExpire;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getLoveMsgPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '一伴回复') {
        Dialog.open({
          title: '一伴回复',
          component: MsgReplyDialog,
          data: {
            row: row,
            width: '600px'
          },
          confirm: () => {
            for(let i=0;i<this.pageDataList.length;i++) {
              if(this.pageDataList[i].msgId == row.msgId) {
                this.pageDataList.splice(i, 1);
              }
            }
          }
        })
      }

    },

    batchUpdate(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 2?'【通过】':'【不通过】') +'选中用户').then(()=>{
          if(state == 2) {
            this.bitchPassLoading = true;
          }else {
            this.bitchRejectLoading = true;
          }
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray
          param['state'] = state
          postFormData(updateLoveMsgState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['msgId'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.bitchPassLoading = false;
            _this.bitchRejectLoading = false;
          })
              .catch(()=>{
                _this.bitchPassLoading = false;
                _this.bitchRejectLoading = false;
              })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    // batchUpdate(state) {
    //   if(this.idArray.length > 0) {
    //     let _title = (state == 2?'通过':'不通过') + '后的系统通知内容：'
    //     let _this = this
    //     Dialog.open({
    //       title: _title,
    //       component: updateMsgStateDialog,
    //       data: {
    //         idArray: this.idArray,
    //         state: state,
    //         width: '500px',
    //       },
    //       confirm: (()=>{
    //         for(let j=0;j<_this.idArray.length;j++){
    //           for(let i=0;i<_this.pageDataList.length;i++) {
    //             if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
    //               _this.pageDataList.splice(i,1);
    //               i--;
    //             }
    //           }
    //         }
    //         if(_this.pageDataList.length == 0){
    //           _this.getPage();
    //         }
    //       })
    //     })
    //   } else {
    //     this.$message({
    //       showClose: true,
    //       duration: 1000,
    //       message: '请至少选择一个用户进行操作',
    //       type: 'warning'
    //     })
    //   }
    // },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList
      })
    }

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
